export function formatDialogContent(contentParam: string|React.ReactNode) {
  return typeof contentParam === 'string'
    ? <p>{contentParam}</p>
    : contentParam;
}